const INITIAL_STATE = {
  todos: "",
  erro: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){ 
    case 'ERRO':
      return {...state, erro: action.erro};
    case 'TODOS':
      return {...state, todos: action.todos};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/NomesArquivosFechamentoReducer.js